import React, { PropTypes } from 'react';
import ImageSequence from 'components/ui/animation/ImageSequence.jsx';

class Home extends React.Component {

  // ==================================================================================
  // CONSTRUCTOR ----------------------------------------------------------------------

  constructor() {
    super();
  }


  // ==================================================================================
  // EVENT INTERFACE ------------------------------------------------------------------

  // handleUpdate();


  // ==================================================================================
  // INTERNAL INTERFACE ---------------------------------------------------------------

  render() {
    return(
      <div className="section home">
        <ImageSequence />
      </div>
    );
  }
}


export default Home;



/** WEBPACK FOOTER **
 ** ./src/app/components/sections/Home.jsx
 **/